import config from '../config/config';

/**
 * DV-310 Foundational Education links (admin side).
 *
 * Every call takes `getToken`, normally `getAccessToken` from useAuth(), so the token is
 * refreshed when it is about to expire instead of being read stale from localStorage.
 * Calls resolve to the envelope's `data` and reject with an Error carrying the backend's
 * `message` (and the HTTP `status`).
 */
const BASE_PATH = '/um/v1/admin/foundational-education';

const request = async (getToken, path = '', { method = 'GET', body } = {}) => {
  const token = await getToken();
  if (!token) throw new Error('Your session has expired. Please log in again.');

  let res;
  try {
    res = await fetch(`${config.API_BASE_URL}${BASE_PATH}${path}`, {
      method,
      headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
      body: body !== undefined ? JSON.stringify(body) : undefined,
    });
  } catch {
    throw new Error('Could not reach the server. Check your connection and try again.');
  }

  // DELETE answers with a null payload; tolerate an empty body too.
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const error = new Error(data.message || `Request failed (${res.status})`);
    error.status = res.status;
    throw error;
  }
  return data.data !== undefined ? data.data : null;
};

const FoundationalEducationService = {
  /** All links, inactive ones included, in display order. */
  list: (getToken) => request(getToken),
  /**
   * payload (LinkRequest): { titleEn, titleEs, descriptionEn, descriptionEs, urlEn, urlEs,
   * sortOrder, active }
   */
  create: (getToken, payload) => request(getToken, '', { method: 'POST', body: payload }),
  /** Full replace: send every LinkRequest field, also to toggle `active` or change `sortOrder`. */
  update: (getToken, id, payload) => request(getToken, `/${id}`, { method: 'PUT', body: payload }),
  remove: (getToken, id) => request(getToken, `/${id}`, { method: 'DELETE' }),
};

export default FoundationalEducationService;
